<article>
  <nb-menu #menu [items]="items" [autoCollapse]="false"></nb-menu>
  <section>
    <div class="policy">
      <label><a href="https://www.teamertime.com" target="_blank"><img src="assets/teamertime-solo.png" alt="TeamerTime" class="sidebar-logo"><span class="sidebar-copy">&copy; {{ year() }}</span></a></label>
      <div>
        <span>{{ 'v' + Globals.version }}</span>
        <a href="assets/files/flix_it_privacy_policy.pdf" target="_blank">{{ 'privacypolicy' | translate }}</a>
        <a href="assets/files/flix_it_terms_of_service.pdf" target="_blank">{{ 'termsconditions' | translate }}</a>
      </div>
    </div>
  </section>
</article>
